import React, { Suspense, lazy } from "react";
import HeroSection from "./pages/HeroSection";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CampusPartner from "./pages/CampusPartner";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import CampusAmbassadorForm from "./pages/CampusRegistration";
import CampusBrochureAmity from "./pages/CampusBrochureAmity";
import CampusBrochureVIT from "./pages/CampusBrochureVIT";
import CampusBrochureSRM from "./pages/CampusBrochureSRM";
import CampusBrochureKIIT from "./pages/CampusBrochureKIIT";
import EventsPage from "./pages/EventsPage";
import PlansPage from "./pages/PlansPage";
import { CityListPage, CityPage } from "./cities/CityPages";
import CommunitiesPage from "./pages/CommunitiesPage";
import CommunityPage from "./pages/CommunityPage";
import PlanPage from "./pages/PlanPage";
import { BlogListPage, BlogPostPage } from "./blog/BlogPages";

// Event RSVP page (shared event links). Loaded only when someone opens an event link.
const EventRsvpPage = lazy(() => import("./rsvp/EventRsvpPage"));

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<HeroSection />} />
          <Route path="/blogs" element={<BlogListPage />} />
          <Route path="/blogs/:slug" element={<BlogPostPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/things-to-do" element={<CityListPage />} />
          <Route path="/things-to-do/:city" element={<CityPage />} />
          <Route path="/communities" element={<CommunitiesPage />} />
          <Route path="/communities/:communityId" element={<CommunityPage />} />
          <Route path="/plan/:planId" element={<PlanPage />} />
          {/* Jobs is replaced by Communities for now. */}
          <Route path="/jobs" element={<Navigate to="/communities" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/campus-partner" element={<CampusPartner />} />
          <Route path="/partner-registration" element={<CampusAmbassadorForm />} />
          <Route path="/partner-brochure-amity" element={<CampusBrochureAmity />} />
          <Route path="/partner-brochure-vit" element={<CampusBrochureVIT />} />
          <Route path="/partner-brochure-srm" element={<CampusBrochureSRM />} />
          <Route path="/partner-brochure-kiit" element={<CampusBrochureKIIT />} />
          <Route path="/event/:eventId" element={<Suspense fallback={null}><EventRsvpPage /></Suspense>} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
